export const BADGE_IMAGE_BY_KEY = Object.freeze({
  ga_red: "/badges/ga-red.svg",
  ga_fire: "/badges/ga-fire.svg",
  ga_ice: "/badges/ga-ice.svg",
  ga_boss: "/badges/ga-boss.svg",
  ga_street: "/badges/ga-street.svg",
  ga_gold: "/badges/ga-gold.svg",
  admin: "/badges/admin-badge.png",
  founder: "/badges/founder-badge.png",
  founding_member: "/badges/founding-member.svg",
  first_upload: "/badges/first-upload.svg",
  clip_creator: "/badges/clip-creator.svg",
  tournament_competitor: "/badges/tournament-competitor.svg",
  tournament_champion: "/badges/champion-badge.png",
  viewer_1h: "/badges/viewer-1h.svg",
  viewer_10h: "/badges/viewer-10h.svg",
  viewer_25h: "/badges/viewer-25h.svg",
  viewer_50h: "/badges/viewer-50h.svg",
  viewer_100h: "/badges/viewer-100h.svg",
  custom_badge: "/badges/custom-badge.svg",
});

export function toAbsoluteBadgeUrl(value = "", apiBase = "") {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("data:") ||
    raw.startsWith("blob:")
  ) {
    return raw;
  }

  // Public client assets should continue to load from the current web origin.
  if (raw.startsWith("/badges/")) return raw;

  const base = String(apiBase || "").replace(/\/+$/, "");
  if (!base) return raw;
  return `${base}${raw.startsWith("/") ? "" : "/"}${raw}`;
}

export function resolveBadgeImage(badgeKey = "", customBadgeUrl = "", apiBase = "") {
  const key = String(badgeKey || "").trim();
  if (!key) return "";

  if (key === "custom_badge" && customBadgeUrl) {
    return toAbsoluteBadgeUrl(customBadgeUrl, apiBase);
  }

  return toAbsoluteBadgeUrl(BADGE_IMAGE_BY_KEY[key] || "", apiBase);
}
